import React from 'react';
import { PDFDownloadLink, Image, Page, Table, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  title: {
    fontSize: 25,
  },
});

const Title = ({ children }) => <Text style={styles.title}>{children}</Text>;

export default Title;